module.exports = __webpack_public_path__ + "img/dashboard-section-browseLibrary.7935f19e.svg";